import React from 'react'
import styles from './Notice.scss'
import PropTypes from 'prop-types'
import { classNames, variationName } from './../../utils/styles'

export default class Notice extends React.PureComponent {
  render() {
    return (
      <div className={classNames(styles.Notice, this.props.type && styles[variationName('type', this.props.type)])}>
        {this.props.children}
      </div>
    )
  }
}

Notice.propTypes = {
  children: PropTypes.any,
  type: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/components/Notice/index.js